var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "both-pd-box" },
    [
      _c(
        "div",
        [_c("h3", [_vm._v("云发单")]), _vm._v(" "), _c("el-divider")],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "form",
          staticClass: "form-content",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "150px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "云发单AppKey", prop: "appKey" } },
            [
              _c("el-input", {
                staticClass: "form-input",
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.form.appKey,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "appKey", $$v)
                  },
                  expression: "form.appKey",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "云发单AppSecret", prop: "appSecret" } },
            [
              _c("el-input", {
                staticClass: "form-input",
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.form.appSecret,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "appSecret", $$v)
                  },
                  expression: "form.appSecret",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "云发单Agentcode", prop: "agentCode" } },
            [
              _c("el-input", {
                staticClass: "form-input",
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.form.agentCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "agentCode", $$v)
                  },
                  expression: "form.agentCode",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "readonly-form-item",
              attrs: { label: "云发单页面链接" },
            },
            [
              _c(
                "div",
                { staticClass: "readonly-link-wrapper" },
                [
                  _c("div", { staticClass: "readonly-link-box" }, [
                    _vm.form.pageLink
                      ? _c("span", { staticClass: "readonly-link-text" }, [
                          _vm._v(_vm._s(_vm.form.pageLink)),
                        ])
                      : _c(
                          "span",
                          {
                            staticClass: "readonly-link-text placeholder-text",
                          },
                          [
                            _vm._v(
                              "配置完成上面参数并保存后，自动生成云发单配置链接"
                            ),
                          ]
                        ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "copy-btn",
                      attrs: { disabled: !_vm.form.pageLink },
                      on: {
                        click: function ($event) {
                          return _vm.handleCopy(_vm.form.pageLink)
                        },
                      },
                    },
                    [_vm._v("复制")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "link-tip" }, [
                _vm._v("使用云发单功能时，将该链接配置在营销位即可"),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "readonly-form-item",
              attrs: { label: "云发单素材库链接" },
            },
            [
              _c(
                "div",
                { staticClass: "readonly-link-wrapper" },
                [
                  _c("div", { staticClass: "readonly-link-box" }, [
                    _vm.form.materialLink
                      ? _c("span", { staticClass: "readonly-link-text" }, [
                          _vm._v(_vm._s(_vm.form.materialLink)),
                        ])
                      : _c(
                          "span",
                          {
                            staticClass: "readonly-link-text placeholder-text",
                          },
                          [
                            _vm._v(
                              "配置完成上面参数并保存后，自动生成云发单配置链接"
                            ),
                          ]
                        ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "copy-btn",
                      attrs: { disabled: !_vm.form.materialLink },
                      on: {
                        click: function ($event) {
                          return _vm.handleCopy(_vm.form.materialLink)
                        },
                      },
                    },
                    [_vm._v("复制")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "link-tip" }, [
                _vm._v("使用云发单素材库功能时，将该链接配置在营销位即可"),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saveLoading },
                  on: { click: _vm.handleSave },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.handleReset } }, [
                _vm._v("重置"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip-banner" }, [
      _c("p", [
        _vm._v(
          '1. 云发单联系管理员开通后，将云发单后台【账户管理】-【核心配置】内的"云发单AppKey""云发单AppSecret""Agentcode"三个参数配置在此处'
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          '2. 配置完成后，点击"保存"，系统自动解析出来"云发单链接和云发单素材库链接"，将链接配置在需要的营销位即可使用'
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }